import {Message} from '@baidu/acud-element-ui';
import {uploadImage, getTicketType} from '@/znzs/src/api/robot.js';
import {formatFileSize} from '@/znzs/new_src/utils';
import store from '@/znzs/new_src/vuex';
import {safeOpenTab as oldSafeOpenTab} from '@/znzs/src/utils/';
export {timestampToTime, formatFileSize, isOffcialDoc, beforeSend} from '@/znzs/src/utils/';
import {useChatStoreOut} from '@/znzs/new_src/store/chatStore';

export const createDialogId = () => Date.now() + Math.random().toString(16).slice(2);

/**
 * 图片上传
 * @param {*} file
 * @returns
 */
export const upload = async (file, sizeLimit = 5 * 2 ** 20) => {
    if (!file?.size) {
        return;
    }
    if (file.size > sizeLimit) {
        Message.warning(`图片最大不得超过${formatFileSize(sizeLimit, 0)}`);
        return;
    }
    try {
        const formData = new FormData();
        formData.append('file', file);
        const res = await uploadImage(formData);
        return res;
    }
    catch {
        Message.warning(`${file.name}上传失败`);
        return;
    }
};

/**
 * 跳转
 * @param {*} url
 * @param {boolean} forceJump 默认新标签页打开，为false的情况下在服务与支持中，才切换tab
 */
export const jumpPage = (url, forceJump = true) => {
    if (window.isSupport && !forceJump) {
        // https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/-ikorFqd5i/wKWO72VC7h/usqm9lubkTPOTf#anchor-58b0875a-05dd-11ef-ae77-0decca5c1439
        window.top.postMessage({
            channel: 'jump',
            data: {
                url,
                show: '',
            },
        });
    }
    else {
        // 有被工单嵌套的情况，所以直接调用window.top
        window.top.location.href = url;
    }
};

/**
 * 打开新标签页
 * @param {*} url
 * @param {boolean} forceJump 默认新标签页打开，为false的情况下在服务与支持中，才切换tab
 */
export const safeOpenTab = (url, forceOpen = true) => {
    if (window.isSupport && !forceOpen) {
        // https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/-ikorFqd5i/wKWO72VC7h/usqm9lubkTPOTf#anchor-58b0875a-05dd-11ef-ae77-0decca5c1439
        window.top.postMessage({
            channel: 'jump',
            data: {
                url,
                show: 'newPage',
            },
        });
    }
    else {
        return oldSafeOpenTab(url);
    }
};

/**
 * 小窗打开官网文档，
 * @param {*} url
 */
export const safeOpenDoc = url => {
    if (window.isSupport) {
        // https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/-ikorFqd5i/wKWO72VC7h/usqm9lubkTPOTf#anchor-58b0875a-05dd-11ef-ae77-0decca5c1439
        window.top.postMessage({
            channel: 'link',
            data: {
                url,
                show: 'miniWindow',
            },
        });
        window.event?.stopPropagation();
    }
};

export function isUrlEncoded(url) {
    if (!url) {
        return false;
    }
    let isEncoded = false;
    try {
        isEncoded = decodeURIComponent(url) !== url;
    }
    catch (e) { }
    return isEncoded;
}

/**
 * 获取服务类型，
 * e.g bcc aca
 * @returns
 */
export const getServiceName = source => {
    const url = new URL(location.href);
    let serviceName = url.searchParams.get('serviceType') ?? '';
    if (!serviceName && source) {
        const sourceUrl = isUrlEncoded(source) ? decodeURIComponent(source) : source;
        // 获取类型
        const pathname = new URL(sourceUrl).pathname;
        const result = pathname.match(/\/([^\/\.]+)+/g);
        if (result && result.length) {
            serviceName = result.filter(item => !item.startsWith('/product'))[0];
        }
    }
    serviceName = serviceName.replace(/znzs|ticket/, '').slice(1).toUpperCase();
    if (window.SERVICE_TYPE) {
        const service = window.SERVICE_TYPE[serviceName];
        if (service) {
            return service.serviceType;
        }
    }
    return serviceName;
};

let querySessionTask = null;
/**
 * 并发获取当前会话类型
 * @returns
 */
export async function concurrencyQuerySession(force = false) {
    const chatStore = useChatStoreOut();
    if (querySessionTask && !force) {
        return querySessionTask;
    }
    querySessionTask = new Promise(async resolve => {
        const res = await getTicketType();
        if (res?.success) {
            chatStore.setSessionInfo(res?.data);
            store.commit('setTicketTypeIds', res?.data);
        }
        resolve(res);
    });
    setTimeout(() => {
        querySessionTask = null;
    }, 5000);

    return querySessionTask;
}

/**
 * 判断一个元素是否包含指定的类名
 *
 * @param {HTMLElement} element 要判断的元素
 * @param {string} className 要判断的类名
 * @returns {boolean} 如果元素包含指定的类名，则返回 true，否则返回 false
 */
export const hasClass = (element, className) => {
    if (!element || !className) {
        return;
    }
    if (element.classList) {
        return element.classList.contains(className);
    }
    return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);

};

/**
 * 给指定的元素添加指定的类名
 *
 * @param element 需要添加类名的元素
 * @param className 要添加的类名
 */
export const addClass = (element, className) => {
    if (!element || !className) {
        return;
    }
    if (element.classList) {
        element.classList.add(
            className
        );
    }
    else {
        element.className += ' ' + className;
    }
};

/**
 * 从元素中移除指定的类名
 *
 * @param element DOM元素
 * @param className 要移除的类名，可以包含多个类名，用空格分隔
 */
export const removeClass = (element, className) => {
    if (!element || !className) {
        return;
    }
    if (element.classList) {
        element.classList.remove(
            className
        );
    }
    else {
        element.className = element.className.replace(
            new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'),
            ' '
        );
    }
};
/**
 * 切换元素的类名
 *
 * @param {HTMLElement} element - 要操作的 DOM 元素
 * @param {string} className - 要切换的类名
 * @returns {void}
 */
export const toggleClass = (element, className) => {
    if (!element || !className) {
        return;
    }
    if (hasClass(element, className)) {
        removeClass(element, className);
    }
    else {
        addClass(element, className);
    }
};

/**
 * 时间格式化
 */
export const formatDate = (date, format) => {
    const map = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds(), // 毫秒
    };
    let fmt = format;
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    Object.keys(map).forEach(k => {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(
                RegExp.$1,
                RegExp.$1.length === 1 ? map[k] : ('00' + map[k]).substr(('' + map[k]).length)
            );
        }
    });
    return fmt;
};


/**
 * 账单查询卡片日期选择器配置快捷选择范围
 */
export const pickerOptions = {
    shortcuts: [
        {
            text: '最近一周',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
            },
        },
        {
            text: '本月到今天',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
            },
        },
        {
            text: '最近一个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
            },
        },
        {
            text: '最近三个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
            },
        },
        {
            text: '最近六个月',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                picker.$emit('pick', [start, end]);
            },
        },
        {
            text: '最近一年',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                picker.$emit('pick', [start, end]);
            },
        },
    ],
};


/**
 * 根据所选的月份输出起始和结束时间
 *
 * @param dateStr 选择的时间参数，默认为当前时间
 */
export const formatBytes = dateStr => {
    // 解析 date，生成 startTime 和 endTime
    let startTime = '';
    let endTime = '';
    if (dateStr) {
        const d = new Date(dateStr);
        const year = d.getFullYear();
        const month = d.getMonth(); // 0-based
        // 上月最后一天（使用 UTC 方法避免时区问题）
        const lastDayPrevMonth = new Date(Date.UTC(year, month, 0));
        // 本月最后一天（使用 UTC 方法避免时区问题）
        const lastDayThisMonth = new Date(Date.UTC(year, month + 1, 0));
        // startTime: 上月最后一天 16:00:00 UTC
        startTime = lastDayPrevMonth.toISOString().slice(0, 10) + 'T16:00:00Z';
        // endTime: 本月最后一天 15:59:59 UTC
        endTime = lastDayThisMonth.toISOString().slice(0, 10) + 'T15:59:59Z';
    }
    return {
        startTime,
        endTime,
    };
};

/**
 * 账单查询卡片跳转详情baseurl确认
 *
 */
export const getOriginUrl = () => {
    if (window.location.origin === 'https://console.bce.baidu.com') {
        return 'https://console.bce.baidu.com';
    }
    return 'https://qasandbox.bcetest.baidu.com';
};